<template>
  <div>
    <form @submit.prevent="loadGross" class="mb-4">
      <div class="form-group">
        <label for="min-score" class="mb-1 mr-1">Минимальное количество очков игрока</label>
        <b-icon icon="question-circle" v-b-popover.hover.right="'Если нужно учитывать только вовлеченных игроков, используйте значение больше 0.'"></b-icon>
        <input id="min-score" class="form-control score-input" v-model="minScore" type="number" min="0" required>
      </div>

      <b-button type="submit" variant="primary" size="sm" :disabled="isCalcGrossButtonDisabled">Вычислить сумму платежей</b-button>
    </form>

    <p v-if="isGrossVisible">
      Сумма платежей: {{gross | getFormattedNumber}} USD
    </p>

  </div>
</template>

<script>
import { HTTP } from '../http-common.js';
import notifier from '../notifier.js';

const LOADING_STATUS__INIT    = 1;
const LOADING_STATUS__LOADING = 2;
const LOADING_STATUS__NORMAL  = 3;
const LOADING_STATUS__ERROR   = 4;

export default {
  name: 'ContestChampGross',

  props: {
    contestId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      minScore: 0,

      loadingStatus: LOADING_STATUS__INIT,
      gross: 10,
    };
  },

  computed: {
    /** @returns {boolean} */
    isLoading() {
      return this.loadingStatus === LOADING_STATUS__LOADING;
    },

    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadingStatus === LOADING_STATUS__NORMAL;
    },

    /** @returns {boolean} */
    isCalcGrossButtonDisabled() {
      return this.isLoading;
    },

    /** @returns {boolean} */
    isGrossVisible() {
      return this.isLoadedNormal && (this.gross !== null);
    },
  },

  watch: {
    minScore() {
      this.resetGross();
    },
  },

  created() {
    this.loadGross();
  },

  methods: {
    loadGross() {
      notifier.deleteSenderNotifications(this);

      this.loadingStatus = LOADING_STATUS__LOADING;

      const config = {
        params: {},
      };

      const minScore = this.minScore;
      if(minScore > 0) {
        config.params['min_score'] = minScore;
      }

      const url = `/contest/${this.contestId}/champ_gross`;
      HTTP.get(url, config)
      .then(response => {
        this.gross = response.data.data;
        this.loadingStatus = LOADING_STATUS__NORMAL;
      })
      .catch(err => {
        this.loadingStatus = LOADING_STATUS__ERROR;
        notifier.showError(err, {sender: this});
      });
    },

    resetGross() {
      this.gross = null;
    },
  },
};
</script>

<style scoped>
.score-input {
  max-width: 321px;
}
</style>
